import { createContext, useContext } from 'react';

export interface StepsProps {
  activeStep: number;
  prevSteps: number[];
}

export interface DefaultContextProps {
  data: {
    formData?: any;
    steps: StepsProps;
  };
  commands: {
    handleNextStep: () => void;
    handleFormData: (data: any) => void;
    handleCapture: (docType: string) => void;
    handleStep: (stepId: number) => void;
    sendDonations: any;
  };
}

export const MobileCheckDepositContext = createContext<
  DefaultContextProps | undefined
>(undefined);

export const useMobileCheckDepositContext = () => {
  const context = useContext(MobileCheckDepositContext);
  if (!context) {
    throw new Error('Mobile Check deposit mount failed');
  }
  return context;
};
